import { Text } from '../../../ToolkitV2/Text/Text';
import * as Styled from './FreeHistoryReportTag.styled';
import { Tag } from '../Tag';

const Badge = () => {
  return (
    <Styled.FreeBadge>
      <Text size="B12" color="WHITE" weight="bold" forwardedAs="span">
        FREE
      </Text>
    </Styled.FreeBadge>
  );
};

const FreeHistoryReportTag = () => {
  return (
    <Tag
      text="History Report"
      textColor="GREY_DARK"
      bgColor="GREY_LIGHTER"
      icon={<Badge />}
      iconPosition="LEFT"
      testId="free-history-report-tag"
    />
  );
};

export { FreeHistoryReportTag };
